import { NoSsr } from "@mui/material";
import * as Sentry from "@sentry/nextjs";

import { ExternalWidgetBokun } from "../../components/ExternalWidget/ExternalWidgetBokun";
import { ExternalWidgetBookingkit } from "../../components/ExternalWidget/ExternalWidgetBookingkit";
import { ExternalWidgetFareharbor } from "../../components/ExternalWidget/ExternalWidgetFareharbor";
import { ExternalWidgetPeek } from "../../components/ExternalWidget/ExternalWidgetPeek";
import { ExternalWidgetRezdy } from "../../components/ExternalWidget/ExternalWidgetRezdy";
import { ExternalWidgetTicketinghub } from "../../components/ExternalWidget/ExternalWidgetTicketinghub";
import { ExternalWidgetTravelotopos } from "../../components/ExternalWidget/ExternalWidgetTravelotopos";
import { ExternalWidgetVentrata } from "../../components/ExternalWidget/ExternalWidgetVentrata";
import { ExternalWidgetXola } from "../../components/ExternalWidget/ExternalWidgetXola";
import { ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import { ExternalWidget } from "../../types/ExternalWidget";
import { objectWithoutTypename } from "../../utils/objectWithoutTypename";

export type AvailabilityExternalWidgetProps = {
    widget: ExternalWidget;
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
    onOpen?: () => void;
};

export function AvailabilityExternalWidget({ widget, ButtonComponent, onOpen }: AvailabilityExternalWidgetProps) {
    let content = null;

    if (widget.__typename === "ExternalWidgetRezdy") {
        content = <ExternalWidgetRezdy {...objectWithoutTypename(widget)} />;
    } else if (widget.__typename === "ExternalWidgetBokun") {
        content = <ExternalWidgetBokun {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
    } else if (widget.__typename === "ExternalWidgetXola") {
        content = <ExternalWidgetXola {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
    } else if (widget.__typename === "ExternalWidgetFareharbor") {
        content = <ExternalWidgetFareharbor {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
    } else if (widget.__typename === "ExternalWidgetPeek") {
        content = <ExternalWidgetPeek {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
    } else if (widget.__typename === "ExternalWidgetTicketinghub") {
        content = (
            <ExternalWidgetTicketinghub
                {...objectWithoutTypename(widget)}
                ButtonComponent={ButtonComponent}
                onOpen={onOpen}
            />
        );
    } else if (widget.__typename === "ExternalWidgetBookingkit") {
        content = (
            <ExternalWidgetBookingkit
                {...objectWithoutTypename(widget)}
                ButtonComponent={ButtonComponent}
                onOpen={onOpen}
            />
        );
        if (!widget.subdomain) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetBookingkit"));
            });
        }
    } else if (widget.__typename === "ExternalWidgetTravelotopos") {
        content = <ExternalWidgetTravelotopos {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
        if (!widget.subdomain) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetTravelotopos"));
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    } else if (widget.__typename === "ExternalWidgetVentrata") {
        content = <ExternalWidgetVentrata {...objectWithoutTypename(widget)} ButtonComponent={ButtonComponent} />;
        if (!widget.apiKey) {
            Sentry.withScope((scope) => {
                scope.setTag("product", "externalWidget");
                Sentry.captureException(new Error("No EntityConfiguration for ExternalWidgetVentrata"));
            });
        }
    }

    return <NoSsr>{content}</NoSsr>;
}
